var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/exec/presentation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(5.000000, 4.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path",
    x: 0.5,
    y: 0.75,
    width: 21,
    height: 3,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path",
    x: 2,
    y: 3.75,
    width: 18,
    height: 13.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 20.25,
    x2: 11,
    y2: 17.25,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 9.5,
    x2: 5.5,
    y2: 12.5,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 12.5,
    x2: 7.5,
    y2: 9.5,
    id: "path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 7.5,
    x2: 12.5,
    y2: 12.5,
    id: "path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path",
    cx: 11,
    cy: 21.75,
    r: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.2a5d0ae2b691775c076a07869d4bca87.svg";
export { ForwardRef as ReactComponent };